import { userRoleToTypeMap, userType as userTypes } from "constants/internal"

const getUserTypesByRoles = roles =>
    Object.values(userTypes).filter(userType =>
        roles.some(role => userRoleToTypeMap[role] === userType),
    )

export default getUserTypesByRoles
